module.exports = __webpack_public_path__ + "tile-nitf.png";


//////////////////
// WEBPACK FOOTER
// ./app/tile-nitf.png
// module id = 2
// module chunks = 0